import React from 'react';
import clsx from 'clsx';
import { Table, Radio } from 'semantic-ui-react';
import POSIcon from '../POSIcon';
import TableCell from '../TableCell';
import { TableActions } from '../TableActions/TableActions';
import { Props } from '../../interfaces/GenericTableRowDataProps';
import { CheckButton } from '../../types';

export const Row = <TData, TField, TDataSubItem = TData>(
  props: Props<TData, TField, TDataSubItem>,
  isItemHasSubItems: boolean | '' | undefined,
  isSubItemsOpened: boolean,
  toggleSubItems: (isSubItemsOpened: boolean) => void
) => (
  <Table.Row
    className={clsx({
      'p-os-row-click-handle': !!props.onRowClick,
      'p-os-row-subitems-opened': isSubItemsOpened,
      'p-os-row-selecting-cells-active': props.isSelectingCellsActive,
      'p-os-row-disable': props.disabled,
    })}
    data-testid="p-os-generic-table-row"
    onClick={(e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      props.onRowClick?.(e, props.item);

      if (isItemHasSubItems) {
        const isClickedOnActionSection = (e.target as HTMLElement).closest(
          '.action-icons'
        );

        if (isClickedOnActionSection) return;

        toggleSubItems(!isSubItemsOpened);
      }
    }}
  >
    {props.showArrowForRowWithSubItems && (
      <Table.Cell
        className={clsx({ 'p-os-row-disable-action': props.disabled })}
      >
        {isItemHasSubItems && (
          <POSIcon icon={isSubItemsOpened ? 'arrow-up' : 'arrow-down'} />
        )}
      </Table.Cell>
    )}

    {props.showCheckButton && (
      <Table.Cell
        className={clsx({ 'p-os-row-disable-action': props.disabled })}
      >
        {props.showCheckButton == 'radio' ? (
          <Radio
            checked={props.checked}
            onClick={() => props.onToggle?.(!props.checked)}
            disabled={props.disabled}
          />
        ) : (
          <CheckButton
            checked={props.checked}
            onToggle={(value: boolean) => props.onToggle?.(value)}
            disabled={props.disabled}
          />
        )}
      </Table.Cell>
    )}

    {props.columnDefinitions.map((columnDefinition: any, index: number) => (
      <TableCell
        key={props.getId(props.item) + '_' + columnDefinition.name}
        columnDefinition={columnDefinition}
        getId={props.getId}
        item={props.item}
        rowPosition={props.rowPosition}
        columnPosition={index}
        isSelectingCellsActive={props.isSelectingCellsActive}
        fixedSelectedCells={props.fixedSelectedCells}
        selectedCells={props.selectedCells}
        onSetInitialSelectedCell={props.onSetInitialSelectedCell}
        onSelectingCellsStarted={props.onSelectingCellsStarted}
        onSelectingCellsFinished={props.onSelectingCellsFinished}
        onHoverCell={props.onHoverCell}
      />
    ))}

    {props.actions && (
      <Table.Cell
        width={1}
        className={clsx({ 'p-os-row-disable-action': props.disabled })}
      >
        <TableActions
          checkedItems={props.checkedItems}
          item={props.item}
          {...props.actions}
        />
      </Table.Cell>
    )}
  </Table.Row>
);
